
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/appearance",
      function () {
        return require("private-next-pages/settings/appearance.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/settings/appearance"])
      });
    }
  